import { type CSSProperties } from 'react';

import { SkeletonLoader } from '@/components/loaders';

type Props = {
  style?: CSSProperties;
};

const SVG_WIDTH = 400;
const SVG_HEIGHT = 120;
const MARGIN = 16;

// x and y values for the top of the lower area
const AREA1_POINTS = [
  [0, 70],
  [SVG_WIDTH * 0.1, 86],
  [SVG_WIDTH * 0.2, 75],
  [SVG_WIDTH * 0.3, 79],
  [SVG_WIDTH * 0.4, 92],
  [SVG_WIDTH * 0.5, 88],
  [SVG_WIDTH * 0.6, 82],
  [SVG_WIDTH * 0.7, 59],
  [SVG_WIDTH * 0.8, 68],
  [SVG_WIDTH * 0.9, 59],
  [SVG_WIDTH, 38],
];

// Lower area path (as before)
const AREA1_PATH = `M${AREA1_POINTS.map((point) => point.join(',')).join(' L')} L${SVG_WIDTH},${SVG_HEIGHT} L0,${SVG_HEIGHT} Z`;

// Upper area path: top edge is AREA1_POINTS minus 14px, bottom edge is AREA1_POINTS minus 4px (to create a 10px ribbon with a 4px gap)
const GAP = 4;
const RIBBON_HEIGHT = 25;
const AREA2_TOP = AREA1_POINTS.map(([x, y]) => [x, y - GAP - RIBBON_HEIGHT]);
const AREA2_BOTTOM = AREA1_POINTS.map(([x, y]) => [x, y - GAP]).reverse();
const AREA2_PATH =
  `M${AREA2_TOP.map(([x, y]) => `${x},${y}`).join(' L')}` +
  ` L${AREA2_BOTTOM.map(([x, y]) => `${x},${y}`).join(' L')}` +
  ' Z';

const AreaLoader = ({ style = {} }: Props) => (
  <SkeletonLoader
    style={style}
    viewBox={`-${MARGIN} -${MARGIN} ${SVG_WIDTH + 2 * MARGIN} ${SVG_HEIGHT + 2 * MARGIN}`}
    preserveAspectRatio="none"
  >
    {/* Upper area series (ribbon, with whitespace gap) */}
    <path d={AREA2_PATH} />
    {/* Lower area series (first series) */}
    <path d={AREA1_PATH} />
  </SkeletonLoader>
);

export default AreaLoader;
